"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModalSelector = void 0;

var _reducer = require("./reducer");

var getModalSelector = function getModalSelector(state) {
  return state[_reducer.reducerNamespace];
};

exports.getModalSelector = getModalSelector;